import { api, apiCall } from "@api/api";
import { StreamerCorpus } from "@lib/types/generic";

export type GetStreamerCorpusesRes = StreamerCorpus[];

const getStreamerCorpuses = async () => apiCall(api.post<StreamerCorpus[]>("/listIndexedTalent"));

export default getStreamerCorpuses;
